<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-12">
              <div class="frm-title">
                <div class="heading mt-3">
                  <h3
                    class="text-secondary"
                    style="font-size:20px;margin-bottom:0px"
                  >Tranier Information</h3>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <div class="table-responsive">
                <table class="table table-striped">
                  <thead style="background:#06a6e0">
                    <tr class="text-white">
                      <th>Event Title</th>
                      <th>Facilitator Name</th>
                      <th>Thematic Area</th>
                      <th>City</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>In global training for prevention techniques against drug & dealers</td>
                      <td>Mohammad Ali Akhtar</td>
                      <td>Thematic 1, Thematic 2, Thematic 3</td>
                      <td>Abbottabad</td>
                    </tr>
                    <tr>
                      <td>In global training for prevention techniques against drug & dealers</td>
                      <td>Usama Khan</td>
                      <td>Thematic 1, Thematic 2, Thematic 3</td>
                      <td>Islamabad</td>
                    </tr>
                    <tr>
                      <td>In global training for prevention techniques against drug & dealers</td>
                      <td>Zeeshan Rafiq</td>
                      <td>Thematic 1, Thematic 2, Thematic 3</td>
                      <td>Dera Ismail Khan</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
export default {
  data: () => ({
    isSidebar: false
  }),
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  }
};
</script>

<style scoped>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
</style>



